import { Stack, styled } from "@tm/components"

export const StatusPanel = styled(Stack)({
    boxShadow: "0 1px 5px rgba(0,0,0,.2)",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "2.25em",
    margin: ".5rem .25rem 1rem",
    padding: ".5rem",
})
